export enum ReceiveStatusStepEnum {
  ReceiveStatus,
  RequestRefund,
  RefundSuccess,
  RefundError,
}
